import { type FunctionComponent } from 'react';
import { type ThreadHeaderProps } from 'stream-chat-react';
import { useTranslation } from '../../i18n/resources';
import { StreamCloseIcon } from '../../icons/StreamCloseIcon';
import styles from './ThreadHeader.module.css';

export const ThreadHeader: FunctionComponent<ThreadHeaderProps> = ({
  closeThread,
  thread,
}) => {
  const { t } = useTranslation();
  const replyCount = thread.reply_count ?? 0;

  return (
    <div className={styles.root}>
      <div className={styles.threadInfo}>
        <div className={styles.threadTitle}>{t('prayerStream', 'thread')}</div>
        <div className={styles.replyCount}>
          {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Plural key
            t('prayerStream', 'replies' as any, {
              count: replyCount,
            })
          }
        </div>
      </div>
      <div className={styles.closeIcon}>
        <StreamCloseIcon onClick={closeThread} />
      </div>
    </div>
  );
};
